import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthDataService } from '../auth-data.service';
import { AuthQuery } from '../auth.query';

@Component({
  selector: 'app-activate',
  templateUrl: './activate.component.html',
  styleUrls: ['./activate.component.scss']
})
export class ActivateComponent implements OnInit {
  isLoading = true;
  error: string | null = null;
  isExpired = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthDataService,
    private authQuery: AuthQuery,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      const accountId = params['account_id'];

      if (!token || !accountId) {
        this.error = 'Ungültiger Aktivierungslink';
        this.isLoading = false;
        return;
      }

      // Activate account
      this.authService.activateAccount(token, parseInt(accountId)).subscribe({
        next: (response: any) => {
          if (response.success) {
            // Check if user is admin - skip email verification
            const isAdmin = response.user?.is_admin || response.user?.role === 1 || response.user?.role === 2;
            
            if (isAdmin) {
              // Admin: redirect directly to reports
              this.router.navigate(['/reports'], { replaceUrl: true });
            } else {
              // Non-admin: redirect to change-password with verification required
              // Pass activation token and account_id as fallback in case JWT token isn't available yet
              this.router.navigate(['/auth/change-password'], { 
                queryParams: { 
                  verified: 'false',
                  token: token,  // Activation token as fallback
                  account_id: accountId  // Account ID as fallback
                },
                replaceUrl: true 
              });
            }
          } else if (response.redirect_to_login) {
            // Password already set - redirect to login silently
            console.log('Activation link used but password already set. Redirecting to login.');
            this.router.navigate(['/login'], { replaceUrl: true });
          } else {
            this.error = response.error || 'Aktivierung fehlgeschlagen';
            this.isLoading = false;
          }
        },
        error: (error: any) => {
          console.error('Activation error:', error);
          const errorMessage = error.error?.error || 'Fehler bei der Aktivierung';
          
          if (error.error?.expired || errorMessage.includes('abgelaufen')) {
            this.isExpired = true;
            this.error = 'Ihr Aktivierungslink ist abgelaufen';
            // Redirect to forgot-password page after a short delay
            setTimeout(() => {
              this.router.navigate(['/forgot-pwd'], { 
                queryParams: { 
                  error: 'token_expired',
                  message: 'Ihr Aktivierungslink ist abgelaufen. Bitte fordern Sie einen neuen Link an.'
                },
                replaceUrl: true 
              });
            }, 3000);
          } else if (errorMessage.includes('bereits verwendet') || errorMessage.includes('already used')) {
            this.error = 'Dieser Aktivierungslink wurde bereits verwendet';
            // Redirect to forgot-password page after a short delay
            setTimeout(() => {
              this.router.navigate(['/forgot-pwd'], { 
                queryParams: { 
                  error: 'token_used',
                  message: 'Dieser Aktivierungslink wurde bereits verwendet. Bitte melden Sie sich an oder fordern Sie einen neuen Link an.'
                },
                replaceUrl: true 
              });
            }, 3000);
          } else {
            this.error = errorMessage;
            // Redirect to forgot-password page for other errors
            setTimeout(() => {
              this.router.navigate(['/forgot-pwd'], { 
                queryParams: { 
                  error: 'activation_failed',
                  message: errorMessage
                },
                replaceUrl: true 
              });
            }, 3000);
          }
          this.isLoading = false;
        }
      });
    });
  }

  requestNewToken() {
    this.router.navigate(['/auth/token-expired'], { replaceUrl: true });
  }
}



